import React, { Component } from 'react'
import { getProfile } from '../../redux/actions/profileActions'
import { signOut } from '../../redux/actions/userActions'
import { deleteProfile } from '../../redux/actions/profileActions'
import { toggleNav } from '../../redux/actions/miscActions'
import { connect } from 'react-redux'
import ContactInfoForm from '../utils/ContactInfoForm'
import { Input } from 'antd'


export class User extends Component {
  constructor(props){
    super(props)
    this.state={
      confirmDelete: ''
    }
  }

  componentDidMount=()=>{    
    this.props.toggleNav(true)
    const { uid } = this.props.user.user
    this.props.getProfile(uid)      
  }
  
  componentDidUpdate=(prevProps)=>{
    const { uid } = this.props.user.user
    if(prevProps.user !== this.props.user){
      this.props.getProfile(uid)      
    }
  }
  
  handleConfirm=(e)=>{
    this.setState({
      [e.target.name]: e.target.value.toUpperCase()
    })
  }
  
  handleSignOut=()=>{
    this.props.signOut()
  }
  
  deleteProfile=()=>{
    const { uid } = this.props.user.user
    this.props.deleteProfile(uid)
  }

  render() {
    const { profile, hasProfile } = this.props.profile
    const { displayName } = this.props.user.user
    const { confirmDelete } = this.state
    return (
      <div className="user-page">
        <div className="main-content">
          <div className="contact-info">
          <button onClick={this.handleSignOut}  className="red-button">Uitloggen</button>
            <ContactInfoForm profile={profile} hasProfile={hasProfile} displayName={displayName} user={this.props.user.user}/>
          </div>
        </div>
        <div className="delete-button">
          <p>Type "DELETE" in om uw profiel te verwijderen</p>
          <div>
          <Input  name="confirmDelete" onChange={this.handleConfirm} value={confirmDelete}/>
          <button onClick={this.deleteProfile} className={`red-button ${confirmDelete}`} >DELETE</button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps =(state) => ({
  user: state.user,
  profile: state.profile
})

export default connect(mapStateToProps, { getProfile, toggleNav, signOut, deleteProfile })(User)
